import { useI18n, LANGS } from "@/i18n";

export default function LangSwitcher({ variant = "default" }) {
  const { lang, setLang } = useI18n();
  return (
    <div
      className="inline-flex items-center gap-0.5 rounded-full border border-white/15 p-0.5 bg-black/40 backdrop-blur"
      data-testid="lang-switcher"
      aria-label="Language"
    >
      {LANGS.map((l) => (
        <button
          key={l.code}
          onClick={() => setLang(l.code)}
          className={`text-[10px] font-mono-tech tracking-[0.15em] px-2.5 py-1.5 rounded-full transition-colors ${
            lang === l.code
              ? "bg-white text-black"
              : "text-zinc-400 hover:text-white"
          }`}
          data-testid={`lang-${l.code}`}
          aria-pressed={lang === l.code}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
